import React from 'react'
import { dayjs } from '@mobi/utils/date'
import { toTitleCase } from '@mobi/utils/string'
import { Icon } from '@mobi/component-library/Common/Icon'
import { Flex } from '@mobi/component-library/Common/Flex'
import { spacing } from '@mobi/component-library/Theme/Common'
import { Grid, GridCell } from '@mobi/component-library/Common/Grid'
import { PageHeader } from '@mobi/component-library/Navigation/PageHeader'
import {
  RaceListHeaderStyled,
  RaceListHeaderDetails,
  RaceListCenteredHeaderStyled,
} from './RaceListHeader.styles'
import { RaceCondtitionIcon } from '@core/Areas/RaceList/RaceList.styles'
import { IconTypes, unknownWeather, WeatherTypes } from './utils'

export const RaceListHeader: React.FC<{
  title: string
  code: string
  weather: string
  condition: string
  eventDate: string
}> = ({ title, code, weather, condition, eventDate }) => {
  return (
    <div>
      <PageHeader
        title={
          <Flex gap={spacing.smx1} alignItems='center'>
            <Icon size='2.6rem' type={IconTypes[code]} /> {toTitleCase(title)}
          </Flex>
        }
      />

      <RaceListHeaderStyled data-tid-page-sub-title=''>
        <RaceListCenteredHeaderStyled>
          <Grid>
            <RaceListHeaderDetails>
              <GridCell valign='middle' align='center'>
                {dayjs(eventDate).format('ddd DD MMM YYYY')}
              </GridCell>
              <GridCell valign='middle' align='center'>
                <RaceCondtitionIcon size='1.75rem' type={WeatherTypes[weather] || unknownWeather} />
                {weather}
              </GridCell>
              <GridCell valign='middle' align='center'>
                <RaceCondtitionIcon type='trackConditions' size='1.75rem' />
                {condition}
              </GridCell>
            </RaceListHeaderDetails>
          </Grid>
        </RaceListCenteredHeaderStyled>
      </RaceListHeaderStyled>
    </div>
  )
}
